import type { ShotResult } from './local-state';

export type BadgeId = 'hawkEye' | 'hatTrick' | 'perfect' | 'ironDoor' | 'brilliant';

export interface BadgeMeta { id: BadgeId; emoji: string; i18nKey: string; }

export const BADGES: readonly BadgeMeta[] = [
  { id: 'hawkEye',  emoji: '🦅', i18nKey: 'badge.hawkEye' },
  { id: 'hatTrick', emoji: '⚽', i18nKey: 'badge.hatTrick' },
  { id: 'perfect',  emoji: '🥇', i18nKey: 'badge.perfect' },
  { id: 'ironDoor', emoji: '🛡️', i18nKey: 'badge.ironDoor' },
  { id: 'brilliant', emoji: '💎', i18nKey: 'badge.brilliant' },
];

export function computeBadges(shots: readonly ShotResult[]): BadgeId[] {
  const out = new Set<BadgeId>();
  const goals = shots.filter((s) => s.outcome === 'goal');
  const saves = shots.filter((s) => s.outcome === 'saved').length;
  const score = goals.length;
  const distinctScoring = new Set(goals.map((g) => g.targetZone));

  // hawkEye: ≥4 distinct scoring zones
  if (distinctScoring.size >= 4) out.add('hawkEye');

  // hatTrick: ≥5 consecutive goals (any sliding window across the round)
  let run = 0; let maxRun = 0;
  for (const s of shots) { run = s.outcome === 'goal' ? run + 1 : 0; if (run > maxRun) maxRun = run; }
  if (maxRun >= 5) out.add('hatTrick');

  // perfect: score ≥ 6/7
  if (score >= 6) out.add('perfect');

  // ironDoor: keeper saved ≥3 shots
  if (saves >= 3) out.add('ironDoor');

  // brilliant: 7/7 AND ≥5 distinct
  if (score === 7 && distinctScoring.size >= 5) out.add('brilliant');

  return Array.from(out);
}
